var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section is-title-bar"},[_c('div',[_c('ul',_vm._l((_vm.titleStack),function(title,index){return _c('li',{key:index},[_vm._v(_vm._s(title))])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }